module.exports = __webpack_public_path__ + "cc508095806c9a92af632a53b6b3098e.png";